var _path, _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgGauge1(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 297,
    height: 166,
    viewBox: "0 0 297 166",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M120.845 7.41234C119.006 8.00747 117.998 9.98081 118.593 11.8199C119.188 13.659 121.161 14.6674 123.001 14.0723C148.919 5.68511 176.835 5.76947 202.702 14.3131C204.537 14.9194 206.517 13.9229 207.123 12.0874C207.729 10.2519 206.733 8.27255 204.897 7.66632C177.618 -1.34372 148.179 -1.43268 120.845 7.41234ZM210.766 13.2472C211.544 11.4778 213.61 10.6742 215.379 11.4523C241.677 23.0177 263.609 42.657 277.995 67.5238C278.963 69.1969 278.392 71.338 276.718 72.306C275.045 73.274 272.904 72.7024 271.936 71.0292C258.294 47.4496 237.498 28.8268 212.561 17.8601C210.792 17.0819 209.988 15.0167 210.766 13.2472ZM278.41 75.2877C280.16 74.4676 282.244 75.2219 283.064 76.9723C295.252 102.988 298.838 132.208 293.303 160.399C292.931 162.296 291.091 163.531 289.194 163.159C287.298 162.786 286.062 160.947 286.434 159.05C291.683 132.319 288.282 104.611 276.725 79.9419C275.905 78.1915 276.66 76.1077 278.41 75.2877ZM48.5716 71.5739C46.9096 70.5869 46.3624 68.4394 47.3494 66.7774C62.0186 42.0762 84.1727 22.6881 110.601 11.4233C112.379 10.6653 114.435 11.4924 115.193 13.2706C115.951 15.0488 115.124 17.1048 113.345 17.8627C88.2854 28.5445 67.2779 46.929 53.368 70.3517C52.381 72.0137 50.2336 72.5609 48.5716 71.5739ZM35.5138 160.361C35.9606 162.242 37.8474 163.404 39.728 162.957C41.6086 162.51 42.771 160.623 42.3242 158.743C36.0272 132.239 38.3339 104.418 48.91 79.3136C49.6605 77.5322 48.8247 75.4797 47.0434 74.7293C45.262 73.9788 43.2095 74.8146 42.4591 76.5959C31.3057 103.071 28.8731 132.41 35.5138 160.361Z",
    fill: "url(#paint0_radial_2_1117)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_2_1117)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 36.585,
    cy: 116.585,
    r: 10.5391,
    transform: "rotate(0.25 36.585 116.585)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 36.585,
    cy: 116.585,
    r: 10.5391,
    transform: "rotate(0.25 36.585 116.585)",
    stroke: "#8342D3",
    strokeWidth: 7
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_2_1117",
    x: 0.589397,
    y: 93.7633,
    width: 71.9912,
    height: 71.9912,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4.3913
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.3913
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.207843 0 0 0 0 0.247059 0 0 0 0 0.270588 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2_1117"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 13.1739
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10.9783
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.207843 0 0 0 0 0.247059 0 0 0 0 0.270588 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_2_1117",
    result: "effect2_dropShadow_2_1117"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_2_1117",
    result: "shape"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_2_1117",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(40.4998 164) scale(250.5 312.633)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#672BEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDA572"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGauge1);
export default __webpack_public_path__ + "assets/media/gauge-1.bd7e2c7b.svg";
export { ForwardRef as ReactComponent };